module.exports = __webpack_public_path__ + "img/error-404.55d3d730.png";